import DataTable from 'components/miscellaneous/DataTable/DataTable';

const ClinicsStatsTable = ({clinics, isStandalone}) => {
    return (
        <div className='table'>
            <DataTable headers={[
                {name: 'Clinic ID', id: 'clinic_id'},
                {name: 'Clinic Name', id: 'clinic_name'},
                {name: 'Platforms Count', id: 'platforms'},
                {name: 'Applicators Count', id: 'applicators'},
                {name: 'Treatments', id: 'treatments'},
                {name: 'Errors', id: 'errors'},
            ]} data={clinics.filter(c => c.is_chain === false)} pagination={null} maxHeight={isStandalone ? '100%' : '300px'} />
        </div>
    )
}

export default ClinicsStatsTable;